// @flow
import React from 'react';
import { Form } from 'react-bootstrap';

// constants
import * as layoutConstants from '../../constants/layout';

const LayoutColor = ({ changeLayoutColorScheme, layoutColor, layoutConstants }) => {
    const changeTheme = (e) => {
        changeLayoutColorScheme(e.target.value);
        localStorage.setItem('mode', e.target.value);
    };
    return (
        <>
            <h5 className="mt-4">Esquema de Color</h5>

            <hr className="mt-1" />

            <Form.Check className="form-check form-switch mb-1">
                <Form.Check.Input
                    type="radio"
                    onChange={changeTheme}
                    name="layout-color"
                    value={layoutConstants.LAYOUT_COLOR_LIGHT}
                    id="light-mode"
                    checked={layoutColor === layoutConstants.LAYOUT_COLOR_LIGHT}
                />
                <Form.Check.Label htmlFor="vertical-layout">Modo claro</Form.Check.Label>
            </Form.Check>

            <Form.Check className="form-check form-switch mb-1">
                <Form.Check.Input
                    type="radio"
                    onChange={(e) => changeLayoutColorScheme(e.target.value)}
                    name="layout-color"
                    value={layoutConstants.LAYOUT_COLOR_DARK}
                    id="dark-mode"
                    checked={layoutColor === layoutConstants.LAYOUT_COLOR_DARK}
                />
                <Form.Check.Label htmlFor="horizontal-layout">Modo obscuro</Form.Check.Label>
            </Form.Check>
        </>
    );
};

export default LayoutColor;
